<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
import "vue-datetime/dist/vue-datetime.css";
import "@/../sass/animations.scss";
export default {
  mounted() {
    // const authTimeout = this.$jwt_service.get('authTimeout');
    // if (authTimeout) {
    //   var timeoutDate = new Date();
    //   timeoutDate.setTime(authTimeout);
    //   this.$store.commit('setLogoutTimer', timeoutDate);
    // }
  }
};
</script>

<style src="@fortawesome/fontawesome-free/css/all.css"></style>
<style lang="scss" src="../sass/bootstrap-bits.scss"></style>
<style lang="scss">
.link {
  color: #25f;
  &:hover {
    color: lighten(#25f, 15%);
    text-decoration: none;
  }
}
</style>
